<ng-container *ngIf="modularQuestion">
  <p
    class="first-title"
    translate
    *ngIf="modularQuestion.title == null || modularQuestion.title == ''"
  >
    questionBoard.display.noTitle
  </p>
  <p
    class="first-title"
    *ngIf="modularQuestion.title != null || modularQuestion.title != ''"
  >
    {{ modularQuestion.title }}
  </p>
  <div [ngSwitch]="modularQuestion.type.id">
    <que-autocomplete-question-display
      *ngSwitchCase="eQuestionType.Autocomplete"
      [question]="question"
      [modularId]="modularQuestion.guid"
      [modularOrder]="modularOrder"
    >
    </que-autocomplete-question-display>
    <!-- <que-number-question-display *ngSwitchCase="eQuestionType.Number">
        </que-number-question-display> -->
    <que-phone-number-question-display
      *ngSwitchCase="eQuestionType.PhoneNumber"
      [question]="question"
      [modularId]="modularQuestion.guid"
      [modularOrder]="modularOrder"
    >
    </que-phone-number-question-display>
    <que-fill-question-display
      *ngSwitchCase="eQuestionType.Fill"
      [question]="question"
      [modularId]="modularQuestion.guid"
      [modularOrder]="modularOrder"
    >
    </que-fill-question-display>
    <que-date-question-display
      *ngSwitchCase="eQuestionType.Date"
      [question]="question"
      [modularId]="modularQuestion.guid"
      [modularOrder]="modularOrder"
      [isPreview]="isPreview" 
    >
    </que-date-question-display>
    <!-- <div *ngSwitchCase="eQuestionType.Mark" class="answer" (click)="valueMark=!valueMark">
            <div class="checkbox" [ngClass]="{'checked':valueMark}">
                <div class="img" *ngIf="valueMark">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" viewBox="0 0 16 12" fill="#F05612">
                        <path
                            d="M5.54993 11.6539L0.215332 6.3193L1.28456 5.2501L5.54993 9.51547L14.7153 0.350098L15.7845 1.4193L5.54993 11.6539Z" />
                    </svg>
                </div>
            </div>
        </div> -->
  <!-- [formControl]="modularQuestionForm.controls.apiExposureFieldName"  -->
  <que-display-api-field-name
    class="api-name"
    [name]="modularQuestion.apiExposureFieldName"
  ></que-display-api-field-name>    
  </div>
</ng-container>
